import { ENV } from "@/constants/envConfig";

const S3_BUCKET = "https://koala-web-ordering-themes.s3.amazonaws.com";

export function getS3Path(slug: string, assetPath: string) {
  return `${S3_BUCKET}/${slug}/${ENV}/${assetPath}`;
}
